import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const authToken = localStorage.getItem('auth-token');

    // Do not attach auth header on login calls; some backends reject it
    const isLogin = request.url.includes('login');

    if (!isLogin && authToken && authToken !== 'null' && authToken !== 'undefined') {
      const authRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
      return next.handle(authRequest);
    }

    return next.handle(request);
  }
}
